import { render, staticRenderFns } from "./PendingOrdersCmp.vue?vue&type=template&id=6bd5af62&"
import script from "./PendingOrdersCmp.vue?vue&type=script&lang=js&"
export * from "./PendingOrdersCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports